import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  section: {
    flex: 2,
    minWidth: 0
  },
  field: {
    width: '100%'
  }
});
export default useStyles;